export default __webpack_public_path__ + "static/media/bg-large.1f4a7b9e.jpg";